import React, { useState, useEffect, useCallback } from "react";
import CountUp from "react-countup";

type MyCountUpProps = {
  value: number;
  lastFullyDrawnValue: number | undefined;
  setLastFullyDrawnValue?: (value: number) => void;
  prefix?: string;
  suffix?: string;
  decimals?: number;
  duration?: number;
  negativeIsError?: boolean;
  error?: boolean;
};

function MyCountUp(props: MyCountUpProps) {
  const value = props.value;
  const lastFullyDrawnValue = props.lastFullyDrawnValue;
  const setLastFullyDrawnValue = props.setLastFullyDrawnValue;
  const prefix = props.prefix;
  const suffix = props.suffix;
  const decimals = props.decimals ?? 0;
  const duration = props.duration ?? 2;

  const lowestValueWithSameDigits = 10 ** Math.floor(Math.log10(value));

  const start =
    lastFullyDrawnValue === undefined
      ? ~~Math.max(Math.floor(value / lowestValueWithSameDigits) - 1, 1) * lowestValueWithSameDigits
      : lastFullyDrawnValue; // double tilde makes NaN 0
  const [ended, setEnded] = useState(false);

  useEffect(() => {
    if (ended && setLastFullyDrawnValue !== undefined) {
      setLastFullyDrawnValue(value);
      setEnded(false);
    }
  }, [setLastFullyDrawnValue, value, ended]);

  const params = {
    start: start,
    end: value,
    prefix: prefix,
    suffix: suffix,
    duration: duration,
    decimals: decimals,
    onEnd: () => setEnded(true),
  };

  return isNaN(value) || (props.negativeIsError === true && value < 0) || props.error === true ? (
    <>{(prefix ?? "") + "-" + (suffix ?? "")}</>
  ) : (
    <CountUp {...params} />
  );
}

export default MyCountUp;
